import React from 'react';
import { useLocation } from '../context/LocationContext';
import './LocationModal.css';

const LocationModal = () => {
  const { showLocationModal, updateLocation, setShowLocationModal, locations } = useLocation();

  if (!showLocationModal) return null;

  const handleSelectLocation = (location) => {
    updateLocation(location);
    setShowLocationModal(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Select Your Pickup Location</h2>
        <p>Choose the location where you'd like to pick up your order</p>
        <div className="location-options">
          {locations.map((location) => (
            <button
              key={location}
              className="location-option-btn"
              onClick={() => handleSelectLocation(location)}
            >
              {location}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocationModal;
